angular.module 'app'
.controller 'ReportsCtrl', ($scope, $http, $stateParams, $state, config, Storage, dialogs, growl, SweetAlert) ->

  $scope.ui =
    resourcesUrl: config.resources.baseUrl
    isLoading: false
    totalItems: 0
    currentPage: 1
    perPage: 10
    maxSize: 6
    type: 'Reports'
    figureList: []

  findDatas = ->
    is_public = false
    is_public = true if Storage.get('user_permission').wiplevel and Storage.get('user_permission').wiplevel is "1"
    
    $http.get "#{config.api.baseUrl}/filemanage/file?access_token=" + Storage.get('access_token'),
      params:
        type: $scope.ui.type
        user_id: Storage.get('login_user').id
        limit: $scope.ui.perPage
        offset: ($scope.ui.currentPage - 1) * $scope.ui.perPage
        is_public: is_public
    .then (res) ->
      _.each res.data.data, (data) ->
        data.created_at = moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')
      $scope.ui.totalItems = res.data.count
      $scope.ui.figureList = res.data.data
    .finally ->
      $scope.ui.isLoading = false
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('The network connection failed. Please try again later')

  # # 修改圖文
  $scope.editFigure = (figure) ->
    $state.go("app.addReports", {_id: figure._id})

  #  刪除
  $scope.delFigure = (figure) ->
    SweetAlert.swal {
      title: "Be sure to delete this page?"
      type: "warning"
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      cancelButtonText: 'Cancel'
      confirmButtonText: 'Confirm'
    }, (isConfirm) ->
      if isConfirm
        $http.delete "#{config.api.baseUrl}/filemanage/file/#{figure._id}?access_token=" + Storage.get('access_token'), {}
        .then (res) ->
          findDatas()
          growl.success "Delete successfully!"
        .finally ->
          $scope.ui.isLoading = false
        .catch (error) ->
          if error.data.error.indexOf('errtext') >= 0
            err = JSON.parse error.data.error
            growl.error err.errtext
          else
            growl.error('The network connection failed. Please try again later')

  $scope.$watch 'ui.currentPage', findDatas
